// modules
import { createSelector } from 'reselect'

const providerManagement = (state) => state.admin.providerManagement

export const providerList$ = createSelector(
  providerManagement,
  ({ providerList = [] }) => providerList
)
